import React, { FunctionComponent } from 'react';
import { FormModalPopupFields } from '../@shared/ConsentModal/types/ConsentModal.types';
import './NewsletterFormModalPopup.scss';
import withErrorCatch from '../../helper/withErrorCatch'

import ConsentModal from '../@shared/ConsentModal/ConsentModal';

const NewsletterFormModalPopup: FunctionComponent<{
  fields: FormModalPopupFields;
}> = ({ fields }) => {
  return (
    <div id="NewsletterFormModalPopup" className="NewsletterFormModalPopup">
      <ConsentModal {...fields} origin={'newsletter'} />
    </div>
  );
};

export default withErrorCatch(NewsletterFormModalPopup);
